<template>
    <label class="block text-xs" :class="{
        'border border-transparent text-white ': color === 'primary',
        'border border-transparent text-gray-900  ': color === 'primary-dark',
        'border border-transparent bg-red-600 text-white hover:bg-red-500 focus:border-red-700': color === 'danger',
        'border border-transparent bg-orange-600 text-white hover:bg-orange-500 focus:border-orange-700': color === 'warning',
        'border border-transparent bg-green-600 text-white hover:bg-green-500 focus:border-green-700': color === 'success',
    }">
        <template v-if="name">
            {{ name }}
        </template>
        <slot></slot>
    </label>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: false
        },
        color: {
            required: false,
            type: String,
            default: 'primary'
        },
    }
}
</script>